export function roleReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case "GET_ROLES":
            return payload;
        
        default:
            return state;
    }
}